import dayjs from 'dayjs';

// Jättöpäivä näytössä: pelkkä päivä tai päivä ja kellonaika. Kellonaika on valinnainen ('HH:mm' tai 'HH:mm:ss').
export function deadlineText(date, time) {
  if (!date) return '';
  const day = dayjs(date).format('DD.MM.YYYY');
  return time ? `${day} ${time.slice(0, 5)}` : day;
}

// Jättöpäivä on mennyt: kellonajalla sillä hetkellä, ilman kellonaikaa päivän päätyttyä.
export function deadlinePassed(date, time) {
  if (!date) return false;
  if (time) return dayjs(`${date}T${time.slice(0, 5)}`).isBefore(dayjs());
  return date < dayjs().format('YYYY-MM-DD');
}
